import type { PracticeAppointmentType } from "@/models/practice/PracticeAppointmentType";
import type { LoadPracticeAppointmentTypeAvailabilityResult } from "./load-practice-appointment-type-availability";

interface ShouldEnforceEffectiveAvailabilityInput {
  appointmentType: PracticeAppointmentType;
  appointmentAvailabilityResult: LoadPracticeAppointmentTypeAvailabilityResult;
  hasExplicitHostAvailability: boolean;
}

/**
 * Only explicitly saved availability dimensions should participate in effective-availability enforcement.
 */
export function shouldEnforceEffectiveAvailability({
  appointmentType,
  appointmentAvailabilityResult,
  hasExplicitHostAvailability,
}: ShouldEnforceEffectiveAvailabilityInput): boolean {
  if (!appointmentAvailabilityResult.calendarReadable) {
    return false;
  }

  if (appointmentType.type === "room") {
    return hasExplicitHostAvailability;
  }

  return appointmentAvailabilityResult.hasExplicitAvailability;
}
